import React, { useState, useEffect, useContext } from "react";
import AllTransactionsTable from "./AllTransactionTable2";
import AllTransactionsTable2 from "./AllTransactionsTable";
import '../user-view/custom-tabs.css';
import DownloadBankStatement from "./AccountStatementDownload";

const DashboardReports = () => {
    const [activeTab, setActiveTab] = useState(1);
    const [startDate, setStartDate] = useState(new Date());

    const dateFormatter = (date) => {
        return `${date.getFullYear()}-${
          date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
        }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
      };
      
    const handleTabClick = (index) => {
        setActiveTab(index);
    };


    return (


        <div className="p-4 bg-light" style={{ fontFamily: "auto" }}>

            <div className="card m-0 p-0 pt-3">
                <div className="card-body m-0 p-0">

                    <div className="">
                        <div defaultActiveKey="profile" className=" tab-header justify-content-start">
                           
                            <div
                                className={`tab-item ${activeTab === 1 ? "active" : ""}`}
                                onClick={() => handleTabClick(1)}
                            >
                                Fund Report
                            </div>

                            <div
                                className={`tab-item ${activeTab === 2 ? "active" : ""}`}
                                onClick={() => handleTabClick(2)}
                            >
                                Fund Report 2
                            </div>

                            <div
                                className={`tab-item ${activeTab === 3 ? "active" : ""}`}
                                onClick={() => handleTabClick(3)}
                            >
                                Account Statement Download
                            </div>

                        </div>
                        <div className="tab-content">
                            {activeTab === 1 && <div><AllTransactionsTable2 /></div>}
                        </div>

                        <div className="tab-content">
                            {activeTab === 2 && <div><AllTransactionsTable2 /></div>}
                        </div>


                        <div className="tab-content">
                            {activeTab === 3 && <div><DownloadBankStatement /></div>}
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
};

export default DashboardReports;
